module.exports = __webpack_public_path__ + "static/lightning-slider-basic-4294908c5a9955fe75ae8f226ad25c87.png";